"use client"

import { contentChocoEn, contentChocoId } from "@/constants";
import { useAppContext } from "@/helpers/context/AppContext";
import { useRouter } from "next/navigation";
import React from "react"
import { Container, Image, Nav } from "react-bootstrap"
import parse from 'html-react-parser';

export default function FooterVenue(props) {
    const router = useRouter();
    const context = useAppContext();

    const scrollToGallery = () => {
        const section = document.getElementById('section-gallery');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="footer footer-venue bg-blue">
            <Container className="container-fluid d-flex justify-content-between align-items-center">
                <div className="footer-copyright">
                    <p className="mb-0 text-white small">{ context.lang === 1 ? parse(contentChocoId.copyright): parse(contentChocoEn.copyright)}</p>
                </div>
                <div className="d-flex flex-row flex-1">
                    { !props.landing &&
                        <Nav>
                            <Nav.Link onClick={() => router.push('/')} className="me-4 fw-bold text-white">{ context.lang === 1 ? contentChocoId.linkHome : contentChocoEn.linkHome}</Nav.Link>
                        </Nav>
                    }
                    { !props.landing &&
                        <Nav>
                            <Nav.Link onClick={scrollToGallery}  className="me-5 fw-bold text-white">{ context.lang === 1 ? contentChocoId.linkGallery : contentChocoEn.linkGallery}</Nav.Link>
                        </Nav>
                    }
                    <Nav className="me-2 fw-bold">
                        <Nav.Link href={props.data.facebook} target="_blank" rel="noopener noreferrer" className="p-0 d-flex align-items-center">
                            <Image src="/assets/images/socmed/ic_facebook.png" alt="Facebook" className="icon-socmed"/>
                        </Nav.Link>
                    </Nav>
                    <Nav className="me-2 fw-bold">
                        <Nav.Link href={props.data.twitter} target="_blank" rel="noopener noreferrer" className="p-0 d-flex align-items-center">
                            <Image src="/assets/images/socmed/ic_twitter.png" alt="Twitter" className="icon-socmed"/>
                        </Nav.Link>
                    </Nav>
                    <Nav className="me-2 fw-bold">
                        <Nav.Link href={props.data.instagram} target="_blank" rel="noopener noreferrer" className="p-0 d-flex align-items-center">
                            <Image src="/assets/images/socmed/ic_instagram.png" alt="Instagram" className="icon-socmed"/>
                        </Nav.Link>
                    </Nav>
                    <Nav className="me-2 fw-bold">
                        <Nav.Link href={props.data.tiktok} target="_blank" rel="noopener noreferrer" className="p-0 d-flex align-items-center">
                            <Image src="/assets/images/socmed/ic_tiktok.png" alt="Tiktok" className="icon-socmed"/>
                        </Nav.Link>
                    </Nav>
                </div>
            </Container>
        </div>
    )
}
